import {REHYDRATE} from 'redux-persist';

const initialState = {
  sidebarVisible: true,
  sidebarUnfoldable: false,
  theme: 'light',
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.userSettings,
          sidebarVisible: true,
          sidebarUnfoldable: false,
        };
      }
      return state;

    case 'TOGGLE_SIDEBAR_VISIBILITY':
      return {
        ...state,
        sidebarVisible: !state.sidebarVisible,
      };

    case 'TOGGLE_SIDEBAR_UNFOLDABLE':
      return {
        ...state,
        sidebarUnfoldable: !state.sidebarUnfoldable,
      }

    case 'SET_SIDEBAR_HIDDEN':
      return {
        ...state,
        sidebarVisible: false,
      };

    case 'SET_APP_THEME':
      return {
        ...state,
        theme: action.theme,
      };

    default:
      return state;
  }
}
